import { BrowserRouter, Routes, Route } from 'react-router-dom'
import Layout from './components/Layout'
import Home from './pages/Home'
import SudokuPage from './pages/sudoku/SudokuPage'
import CrosswordPage from './pages/crossword/CrosswordPage'
import RebusPage from './pages/rebus/RebusPage'
import MazePage from './pages/maze/MazePage'
import MathPage from './pages/math/MathPage'

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="sudoku" element={<SudokuPage />} />
          <Route path="crossword" element={<CrosswordPage />} />
          <Route path="rebus" element={<RebusPage />} />
          <Route path="maze" element={<MazePage />} />
          <Route path="math" element={<MathPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  )
}
